import React, { useEffect, useState } from "react";
import "../assets/_reviewForm.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createReview,
  selectReviewStatus,
  selectReviewError,
} from "../store/slices/review";
import BackLink from "./BackLink";
import {
  selectCurrentRdv,
  fetchRendezvousById,
} from "../store/slices/rendezVousSlice";
import { formatDate } from "../utils/utils";

const ReviewForm = () => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [hoveredRating, setHoveredRating] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const status = useSelector(selectReviewStatus);
  const apiError = useSelector(selectReviewError);
  const { id } = useParams();
  const dispatch = useDispatch();
  const currentRdv = useSelector(selectCurrentRdv);

  useEffect(() => {
    if (id) {
      dispatch(fetchRendezvousById(id));
    }
  }, [dispatch, id]);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
    setError("");
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rating === 0 && comment.trim() === "") {
      setError("Veuillez attribuer une note et un commentaire");
      return;
    } else if (rating === 0) {
      setError("Veuillez attribuer une note");
      return;
    } else if (comment.trim() === "") {
      setError("Veuillez écrire un commentaire");
      return;
    }

    const reviewData = {
      rating: rating,
      comment: comment.trim(),
      appointment_id: currentRdv?.id,
      prestation_ids: Array.isArray(currentRdv?.prestation_ids)
        ? currentRdv.prestation_ids
        : [currentRdv?.prestation_ids],
    };

    try {
      const resultAction = await dispatch(createReview(reviewData));
      if (createReview.fulfilled.match(resultAction)) {
        navigate("/compte/review/success");
      } else {
        setError(resultAction.payload?.message || "Une erreur est survenue");
      }
    } catch (err) {
      setError("Une erreur est survenue lors de la soumission");
    }
  };

  return (
    <div className="review-container">
      <header className="header">
        <BackLink />
      </header>

      <div className="review-card">
        <h3>Notez votre professionnel</h3>
        <p className="body">
          Les avis sont publics et pourront être lus par les utilisateurs Twyny.
        </p>

        {currentRdv?.prestations_snapshot?.map((prestation, index) => (
          <div key={index} className="professional-info">
            <h4>{currentRdv?.etablissement?.nom}</h4>
            <p className="body greyA26">
              {currentRdv?.etablissement?.activite?.name || "Activité inconnue"}{" "}
              <img
                className="separator"
                src="/images/separateur.svg"
                alt="séparateur"
              />{" "}
              {prestation?.name}
            </p>
            <p className="body">{formatDate(currentRdv?.start_time)}</p>
          </div>
        ))}

        <div className="rating">
          <h5>Attribuez une note</h5>
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <img
                key={i}
                src={
                  i < (hoveredRating ?? rating)
                    ? "/images/star-filled.svg"
                    : "/images/star-empty.svg"
                }
                alt={`Étoile ${i + 1}`}
                className="star"
                onClick={() => handleRatingChange(i + 1)}
                onMouseEnter={() => setHoveredRating(i + 1)}
                onMouseLeave={() => setHoveredRating(null)}
              />
            ))}
          </div>
        </div>

        <div className="comment-section">
          <p className="legend grey-light">Commentaire</p>
          <textarea
            rows="5"
            cols="50"
            className="body"
            placeholder="Partagez votre expérience avec ce professionnel"
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              setError("");
            }}
            maxLength={1000}
          />
          <span className="char-count">{comment.length}/1000</span>
        </div>

        {(error || apiError) && (
          <p className="p-3 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-3">
            {error || apiError}
          </p>
        )}

        <button
          className="btn-primary w-100 submit-button"
          onClick={handleSubmit}
          disabled={status === "loading"}
        >
          {status === "loading"
            ? "Publication en cours..."
            : "Publier mon avis"}
        </button>
      </div>
    </div>
  );
};

export default ReviewForm;
